import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookieBanner } from "@/components/CookieBanner";
import { SkipLink } from "@/components/SkipLink";
import { MetaPixel } from "@/components/MetaPixel";
import { LocaleSync } from "@/components/LocaleSync";
import Index from "./pages/Index";
import Prenota from "./pages/Prenota";
import Menu from "./pages/Menu";
import Experiences from "./pages/Experiences";
import Location from "./pages/Location";
import Privacy from "./pages/Privacy";
import CookiePolicy from "./pages/CookiePolicy";
import Accessibility from "./pages/Accessibility";
import Palme from "./pages/Palme";
import Novita from "./pages/Novita";
import WagyuExperience from "./pages/WagyuExperience";
import LavoraConNoi from "./pages/LavoraConNoi";
import GiftCard from "./pages/GiftCard";
import MenuFestivi from "./pages/MenuFestivi";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <LocaleSync />
        <SkipLink />
        <MetaPixel />
        <Routes>
          {/* Italian (default) */}
          <Route path="/" element={<Index />} />
          <Route path="/prenota" element={<Prenota />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/corean-experience" element={<Experiences />} />
          <Route path="/location" element={<Location />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/accessibilita" element={<Accessibility />} />
          <Route path="/palme" element={<Palme />} />
          <Route path="/novita" element={<Novita />} />
          <Route path="/experience" element={<WagyuExperience />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
          <Route path="/gift-card" element={<GiftCard />} />
          <Route path="/menu-festivi" element={<MenuFestivi />} />

          {/* English */}
          <Route path="/en" element={<Index />} />
          <Route path="/en/prenota" element={<Prenota />} />
          <Route path="/en/menu" element={<Menu />} />
          <Route path="/en/corean-experience" element={<Experiences />} />
          <Route path="/en/location" element={<Location />} />
          <Route path="/en/privacy" element={<Privacy />} />
          <Route path="/en/cookie-policy" element={<CookiePolicy />} />
          <Route path="/en/accessibility" element={<Accessibility />} />
          <Route path="/en/palme" element={<Palme />} />
          <Route path="/en/novita" element={<Novita />} />
          <Route path="/en/experience" element={<WagyuExperience />} />
          <Route path="/en/lavora-con-noi" element={<LavoraConNoi />} />
          <Route path="/en/gift-card" element={<GiftCard />} />
          <Route path="/en/menu-festivi" element={<MenuFestivi />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
